export const Metrics = {
    maxContentWidth:(1024),
 };
 